






import { Component, Prop, Vue } from 'vue-property-decorator'
import { RoomItem } from './api/hex-interface'
import { getAllRooms } from './api/hex'
@Component({
  components: {
  }
})
export default class App extends Vue {
  private items: RoomItem[] = []
  private hasError = false
  private activeItem: RoomItem = {
    id: '',
    imageUrl: '',
    normalDayPrice: 0,
    holidayPrice: 0,
    name: ''
  }
  async beforeCreate () {
    let data = await getAllRooms()
    if (data instanceof Error) {
      console.error(data.message)
      this.hasError = true
      return false
    } else {
      if (data.success) {
        this.items = data.items
        this.activeItem = data.items[0]
      } else {
        this.hasError = true
        console.error(data)
      }
    }
  }
  sideBarOnHover (id: number) {
    let item = this.items[id]
    if (item) {
      this.activeItem = item
    }
  }
  sideBarOnClick (id: string) {

  }
}
